import type { ReactNode } from 'react';

export const symbol_game_button_r1: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M880-800v486q0 64-44.5 109T727-160H233q-64 0-108.5-45T80-314v-486h800Zm-60 60H140v426q0 39 27.5 66.5T233-220h494q38 0 65.5-27.5T820-314v-426Zm0 0H140h680ZM622-563v200q0 10 7 17t17 7q10 0 17-7t7-17v-245q0-5-3.5-9t-8.5-4h-24q-1 0-8 3l-71 56q-7 5-8 13.5t4 15.5q5 8 14 8t16-5l41-33ZM341-447h43l57 98q3 5 8 8t12 3q14 0 21.5-12.5T482-375l-53-87q26-11 39-29t13-44q0-41-26-62.5T378-619h-57q-13 0-21.5 8.5T291-589v227q0 11 7 17.5t18 6.5q11 0 18-7t7-18v-84Zm0-44v-83h35q26 0 40 11t14 31q0 20-15 30.5T371-491h-30Z"
		/>
	</svg>
);
